// https://info.gosuslugi.ru/articles/%D0%92%D0%B0%D0%BB%D0%B8%D0%B4%D0%B0%D1%86%D0%B8%D1%8F/
export const validateInnCheckSum = (inn: string | number) => {
  inn = inn.toString();

  const checkDigit = function (inn: string, coefficients: number[]) {
    let n = 0;
    for (const i in coefficients) {
      n += coefficients[i] * parseInt(inn[i]);
    }
    return parseInt(((n % 11) % 10).toString());
  };
  const n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
  const n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
  if (n11 === parseInt(inn[10]) && n12 === parseInt(inn[11])) {
    return true;
  }

  return false;
};
